import React, { MouseEventHandler } from "react";
import { Row, Col, Card, Divider, Button } from "antd";
import textStyles from "../../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import ServiceSummaryPayment from "../ServiceSummaryPayment/ServiceSummaryPayment";
import { TTrip } from "../../../types/TripTypes";
import { usePaymentDetailsCtx } from "../../../context/PaymentDetailsContext";
import styles from "../ServiceSummary/ServiceSummaryComponent.module.scss";

type Props = {
  tripCreationDetails: TTrip[];
  handleUseSaveCard: Function;
  handleCheckoutAndUseDifferentCard: MouseEventHandler<HTMLDivElement>;
  isCreateTripLoading: boolean;
};

function ServiceSummeryTripCostCard({
  tripCreationDetails,
  handleUseSaveCard,
  handleCheckoutAndUseDifferentCard,
  isCreateTripLoading,
}: Props) {
  const {
    defaultSavedCreditCardDetails: defaultCreditCard,
    isDefaultSavedCreditCardExists,
  } = usePaymentDetailsCtx();

  return (
    <Card className={styles.costCardsContainer}>
      <Row className={textStyles.normalText20} gutter={[0, 16]}>
        Payment <Col span={24} />
      </Row>

      {tripCreationDetails.map((leg: TTrip, index: number) => (
        <Row
          key={leg.id}
          className={`${styles.legCostsAlign} ${textStyles.boldText14}`}
        >
          <Col span={12}>Trip {index + 1}</Col>
          <Col span={12}>${leg.legCostDetails?.totalCost?.toFixed(2)}</Col>
        </Row>
      ))}

      <Divider className={styles.solidDivider} />

      <Row
        className={`${textStyles.normalText16} ${styles.overallCostAlign}`}
        gutter={[0, 4]}
      >
        <Col span={12}>Total cost</Col>
        <Col span={12}>${tripCreationDetails[0]?.grantTotal?.toFixed(2)}</Col>
        <Col span={24} className={textStyles.normalText14}>
          You'll only be charged after each individual trip is complete.
        </Col>
      </Row>

      <Row className={styles.costSeperationOrderDashed} />

      <Row gutter={[0, 4]}>
        {isDefaultSavedCreditCardExists && (
          <Col span={24} className={textStyles.normalText16}>
            Saved card
          </Col>
        )}
        <Col span={24}>
          <Row align="middle" gutter={[10, 0]}>
            <ServiceSummaryPayment />
          </Row>
        </Col>
      </Row>

      {defaultCreditCard ? (
        <>
          <Row className={styles.costSeperationOrderDashed} />
          <Col
            span={24}
            className={styles.useDiffCardStyle}
            onClick={handleCheckoutAndUseDifferentCard}
          >
            <span className={styles.diffCardStyle}> Use a different card</span>
          </Col>
        </>
      ) : null}
      <Row className={styles.costSeperationOrderDashed} />
      <Col id={styles.checkoutButtonContainer} span={24}>
        <Button
          className={
            defaultCreditCard
              ? styles.checkoutButton
              : styles.checkoutButtonDisabled
          }
          onClick={() =>
            handleUseSaveCard(defaultCreditCard.paymentInstrumentId)
          }
          loading={isCreateTripLoading}
        >
          Checkout
        </Button>
      </Col>
    </Card>
  );
}

export default ServiceSummeryTripCostCard;
